




































































































































































































































































import _, { toNumber } from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Table, Row, Column, convertToObjects } from '@/main/utils/table';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';
import { store } from '../store/edit';
import { NAME, WITHOUT_GST_COLUMN_NAME, GST_COLUMN_NAME,EXT_LABOR_COLS, SPLIT_BILLING, EXTLABOUR, MIN_DISCOUNT_LIMIT, MAX_DISCOUNT_LIMIT, MIN_FIELD_LEVEL, EXT_LO_TABLE, ROW_SAVED, ROW_EDIT_CLICKED } from './constants';
import { DropdownItem } from '@/main/store/@types/dropdown';
import { ZAKAZKA_DRUH, ZAKAZKA_STAV } from '../constants';
import { getStavZakazka } from '../utils';
import { apiProvider } from './api';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { showAlert, getMessageType, MessageTypeStatus } from '@/main/utils/notifications';
import { UserRole, EditableStatus } from '@/main/components/constants';
import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

export default EditStoreMixin.extend({
	name: `${NAME}Card`,
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			NAME,
			extLaborCols: EXT_LABOR_COLS,
			totalDiscount: 0,
			table: [],
			tableKey: '0',
			loading: true,
			showSplitSharesDialog: false,
			splitShareDialogHeaderText: 'Split Share Details',
			extLaborPrice: null as number | null,
			cancelExtLocalLaborPrice: null as number | null,
			isDiscountEditable: true,
			isElementEditable: true,
			multipleSelection: [],
			multipleSelectionLaborRevert: [],
			showMarkComplete: false,
			showDelete: false,
			showRevert: false,
			eoTypeId: 0,
			originalDiscountPercent: null as number | null,
			originalDiscountAmount: null as number | null,
			discountAmountReverted: false,
		};
	},
	mounted() {
		this.refreshTable(EXT_LO_TABLE);
	},
	computed: {
		...genVuexComputeds(store),
		isWorkCompleteVisible(): boolean {
			return (this.showMarkComplete && !this.isSalesCounterOrder && this.canEditTableInReleaseMode
			&& (this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.SERVICE_ADVISER || this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.ADMIN
			|| this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.PARTS_MANAGER));
		},
		externalLoName(): string {
			return NAME;
		},
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		name(): string {
			return NAME;
		},
		isDiscountEnabled(): boolean {
			return (this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE);
		},
		canEditTableInReleaseMode(): boolean {
			return ((this.isSplitBillingAvailableForOrderType() || this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE)
			&& (this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA));
		},
		isSalesCounterOrder(): boolean {
			return this.ZakazkaDruh! === ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		externalLoTable(): any {
			this.disableColumns(this.dependentTables.ZakazkaCiziVykony);
			let idColumn: number;
			_.forEach(this.dependentTables.ZakazkaCiziVykony.columns, (col: Column) => {
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});
			return this.dependentTables.ZakazkaCiziVykony;
		},
		tableDisabled(): boolean {
			let isReleasedOrder = false;
			if (this.edit.UvolneniDat !== null && this.edit.UzavreniDat === null && !this.isSplitBillingAvailableForOrderType()) {
                isReleasedOrder = true;
			}
			return this.isViewMode || isReleasedOrder;
		}
	},
	methods: {
		handleSelection(rows: any) {
			this.multipleSelectionLaborRevert = rows.filter((x: Row) => this.laborCompletionStatusCheck(x));
			if (this.canEditTableInReleaseMode) {
				this.multipleSelection = rows.filter((x: Row) => !this.laborCompletionStatusCheck(x));
			} else {
				this.multipleSelection = rows;
			}
			if (this.multipleSelection.length !== 0) {
				this.showDelete = true;
				this.showRevert =true;
				this.showMarkComplete = true;
			} else {
				this.showDelete = false;
				this.showRevert = false;
				this.showMarkComplete = false;
			}
		},
		async refresh( tableName: string){
			await this.fetchTableData([tableName]);
		},
		canRevertLO(): boolean {
			return ((this.zakazkaStav === ZAKAZKA_STAV.OTEVRENA || this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA)  && this.isEditMode);
		},
		async onRowDiscountChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (this.dmsSys.OrderDiscountPrp !== true) {
				updateCol(value, columnId);
				row.cells[columnId] = value;
				return true;
			}
			if	(this.validateRowLevelDiscount(value, updateCol, row) === false) {
				return false;
			}
		},
		validateDiscount(discountper: number) {
			let errormsg = null;
			if ((discountper === 0 || this.loggedUser.DiscountLimitConfigData === null)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} else if (discountper > 0 && discountper < (this.TotDiscPercentLabor === null ? 0 : this.TotDiscPercentLabor)) {
				errormsg = this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer').replace('<DISC_PER>', `${discountper}%`);
			}
			return errormsg;
		},
		checkForDiscountLimit(Level: string = '') {
			if (this.dmsSys.OrderDiscountPrp !== true) return true;
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			else {
				errormsg = this.validateDiscount(
					this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer,
				);
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					message: `${errormsg}${this.LocalizeAndReplace(this.LocalizePopisostatni(Level === 'LI'
						? 'LABOR_ITEM' : 'LABOR_ITEM_TOTAL'), { key: this.LocalizePopisostatni('Level_Limit'), value: '' }).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			
			const startTime = performance.now();
			const laborNumberColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			const itemId = row.cells[laborNumberColId];	
			const eoTypeIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXTERNAL_OPERATION_TYPE_ID;
			this.eoTypeId = row.cells[eoTypeIndex];
			const discountAmountColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_VAL;
			this.originalDiscountAmount = row.cells[discountAmountColId];
			const discountPercentColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT;
			this.originalDiscountPercent = row.cells[discountPercentColId];
			this.discountAmountReverted = false;
			let priceWithoutGstCol: Column[]= this.dependentTables.ZakazkaCiziVykony.columns.filter((item)=>  item.columnName === this.extLaborCols.PC_WITH_GST 
				|| item.columnName === this.extLaborCols.PC_VC_DPH_NAD || item.columnName === this.extLaborCols.PC_BEZ_DPH_NAD);
			priceWithoutGstCol.forEach(column => {
				let newColumn : Column = column!.columns!.find((item)=> item.columnName === this.extLaborCols.PC_PP_SL_PO)!;
				let colId : number = parseInt(newColumn?.columnId);
				if (!Number.isNaN(colId)) {
					this.extLaborPrice = row.cells[colId];
					this.cancelExtLocalLaborPrice = row.cells[colId];
				}
			});			
			this.isDiscountEditable = true;
			this.isElementEditable = true;		    
		
            const laborColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			let isAnyPartyInvoiced = await this.isAnyLabourInvoiced(this.ZakazkaId, row.cells[laborColId], EXTLABOUR);
			this.isElementEditable=isAnyPartyInvoiced?false:true;
			this.isDiscountEditable = isAnyPartyInvoiced?false:true;

			if (isAnyPartyInvoiced) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});			
			}
				// Cancel edit mode if both flags are false
			if (!this.isDiscountEditable && !this.isElementEditable) {
					(this.$refs.editableTable as any).cancelEdit();
			}
			const endTime = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			await zakazkaApiProvider.logPerformance('OrderPrp', 'Order', ROW_EDIT_CLICKED, seconds);
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const startTime = performance.now();
				const quantityColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXT_LO_QUANTITY!;
				const costColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.COST!;
				const unitPriceColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXT_LO_UNIT_PRICE!;
				const unitOfMeasurementColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.UNIT_OF_MEASUREMENT!;
				const supplierNameColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.SUPPLIER_NAME!;
				const discountColIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT!;
				const eoTypeIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXTERNAL_OPERATION_TYPE_ID;

				newRow.cells[eoTypeIndex] = this.eoTypeId;
				const quantity = newRow.cells[quantityColIndex];
				const cost = newRow.cells[costColIndex];
				const unitPrice = newRow.cells[unitPriceColIndex];
				const unitOfMeasurement = newRow.cells[unitOfMeasurementColIndex];
				const supplierName = newRow.cells[supplierNameColIndex];
				const discount = newRow.cells[discountColIndex];

				this.calculateDiscountValue(newRow);

				if (discount! < MIN_DISCOUNT_LIMIT || discount > MAX_DISCOUNT_LIMIT) {
					newRow.cells[discountColIndex] = MIN_FIELD_LEVEL;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
						options: { type: 'error' },
					});
					return false;
				}

				if (unitPrice! <= MIN_DISCOUNT_LIMIT) {
					newRow.cells[unitPriceColIndex]=null;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('Unit_Price_Validation'),
						options: { type: 'error' },
					});
					return false;
				}
	
				if (cost! <= MIN_DISCOUNT_LIMIT) {
					newRow.cells[costColIndex]=null;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('Cost_Validation'),
						options: { type: 'error' },
					});
					return false;
				}

				if (quantity! <= MIN_DISCOUNT_LIMIT) {
					newRow.cells[quantityColIndex] = null;
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('Quantity_Validation'),
						options: { type: 'error' },
					});
					return false;
				}

				if (unitOfMeasurement === null || unitOfMeasurement === undefined || unitOfMeasurement === '') {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('Unit_Of_Measurement_Validation'),
						options: { type: 'error' },
					});
					return false;
				}
				if (supplierName === null || supplierName === undefined || supplierName === '') {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('Supplier_Name_Validation'),
						options: { type: 'error' },
					});
					return false;
				}

				const itemIdColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
				const discountAmountColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_VAL;
				const itemId: number = +(newRow.cells[itemIdColId] ?? 0);
				if (itemId > 0) {
					const validationResponse = await zakazkaApiProvider.validateGrossDiscountAmountForSplitParties(
						this.ZakazkaId!,
						itemId,
						EXTLABOUR,
						newRow.cells[discountAmountColId] ?? 0,
						this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0,
						0,
						0,
					);
					const validationMessage: string = validationResponse?.data;
					if (validationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(validationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						// Revert to the original value only on the first validation failure, keep user input on subsequent failures
						if (!this.discountAmountReverted) {
							newRow.cells[discountAmountColId] = this.originalDiscountAmount;
							newRow.cells[discountColIndex] = this.originalDiscountPercent;
							this.discountAmountReverted = true;
						}
							this.$nextTick(() => {
							const editableTable: any = this.$refs.editableTable;
							const rowIndex = editableTable.editTableRows.indexOf(newRow);
							if (rowIndex >= 0) {
								editableTable.editRow(rowIndex, newRow);
							}
						});
						return false;
					}
				}

				const serviceJobColIndex: number =  this.dependentTables.ZakazkaCiziVykony.cellNames!.SERVICE_JOB_NAME!;
				const newServiceJobId = newRow.cells[serviceJobColIndex];
				// On first-time external labour insertion with a selected service job, validate split-party discount limits.
				if (!(itemId > 0) && newServiceJobId! > 0) {
					const { data: insertionValidationMessage } = await apiProvider.validateServiceJobWhileExternalLoInsertion(
						newServiceJobId,
						this.ZakazkaId!,
						this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0,
						+(unitPrice ?? 0),
						+(quantity ?? 0),
					);
					if (insertionValidationMessage) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky(insertionValidationMessage),
							options: { type: 'error' },
							localizeMessage: false,
						});
						newRow.cells[serviceJobColIndex] = null;
						return false;
					}
				}
				// Observation Implementation
				if (newServiceJobId! > 0 && await this.isWarrantyOrGoodwillExistInServiceJobSplit(newServiceJobId)) {
					showAlert({
						message: this.LocalizeChyboveHlasky(`Cant_Map_Service_Job_With_Saga_Splits`),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}

				this.extLaborPrice = newRow.cells[this.dependentTables.ZakazkaCiziVykony.cellNames!.PC_PP_SL_PO];
				this.Sleva = newRow.cells[this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT];
				const endTime = performance.now() - startTime;
				let seconds = parseFloat((endTime / 1000).toFixed(2));
				await zakazkaApiProvider.logPerformance('OrderPrp', 'Order', ROW_SAVED, seconds);
				return true;
			} finally {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		disableColumns(table: Table | Column) {
			_.forEach(table.columns, (col) => {
				if (col.columnName === this.extLaborCols.BILL_TO) {
					col.iconClass = 'el-icon-info';
				}
				if (_.has(col, 'columns')) {
					this.disableColumns(col);
				}
			});
		},
		rowCancel(row: any) {
			if (row !== undefined && row.row !== undefined) {
				let priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaCiziVykony.columns.filter((item) => item.columnName === this.extLaborCols.PC_WITH_GST
					|| item.columnName === this.extLaborCols.PC_VC_DPH_NAD || item.columnName === this.extLaborCols.PC_BEZ_DPH_NAD);
				this.extLaborPrice = this.cancelExtLocalLaborPrice;

				priceWithoutGstCol.forEach(column => {
					let newColumn: Column = column!.columns!.find((item) => item.columnName === this.extLaborCols.PC_PP_SL_PO)!;
					let colId: number = parseInt(newColumn?.columnId);
					row.row!.cells[colId] = this.cancelExtLocalLaborPrice;
				});
			}
		},
		async onRevertLaborClick() {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			let canDelete: boolean = false;
			const markdeleteLabors: number[] = [];
			const laborId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			this.multipleSelectionLaborRevert.map((row: any) => {
				markdeleteLabors.push(row.cells[laborId])
			});

			const { data: isAllPartiesCreditNoteApproved } = await zakazkaApiProvider.isAllPartiesCreditNoteApproved(markdeleteLabors, this.ZakazkaId);
			if (markdeleteLabors.length === 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('notapplicableforRevert') });
			} else if (!isAllPartiesCreditNoteApproved) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Lo_Reversal_Not_Applicable') });
			} else {
				const revertLaborconfirmation = await this.showConfirm({ message: this.LocalizeChyboveHlasky('msgLaborRevertConfirmation'),
				title: getMessageType(MessageTypeStatus.WARNING) });
				if (revertLaborconfirmation) {
					await apiProvider.revertLabors(markdeleteLabors);
					await this.fetchTableData([EXT_LO_TABLE]);
				}
			}
			this.showRevert = false;
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
		async onCompleteMarkClick() {
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			let markCompleteParts = null;
			const markdeleteLabors: number[] = [];
			const laborId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			this.multipleSelection.map((row: any) => {
				markdeleteLabors.push(row.cells[laborId])
			});
			if (markdeleteLabors.some((id: number) => id === undefined || id === null || isNaN(id) || id <= 0)) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('EXTERNAL_LABOR_NOT_SAVED') });
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				return;
			}
			if (await apiProvider.markExtLaborsAsComplte(markdeleteLabors)) {
				const { data: status } = await zakazkaApiProvider.getWorkCompletionStatus({ zakazkaId: this.ZakazkaId! });
				this.IsAllItemLevelStatusEntered = status;
			}
			this.showMarkComplete = false;
			await this.fetchTableData([EXT_LO_TABLE]);
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		isPartyLevelDiscountEnabled(row: Row, columnId: number): boolean {
			const currentRowId = row.cells[this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID];
			if(!(currentRowId > 0)) {
				return false;
			}
			const isPartyLevelDiscEnabledColId = this.dependentTables.ZakazkaCiziVykony?.cellNames?.IS_PARTY_LEVEL_DISCOUNT_ENABLE;
			const discountColId = this.dependentTables.ZakazkaCiziVykony?.cellNames?.DISCOUNT_PERCENT;
			if (isPartyLevelDiscEnabledColId === undefined || isPartyLevelDiscEnabledColId === null) {
				return false;
			}

			if (discountColId === undefined || discountColId === null) {
				return false;
			}
			const discountValue = row.cells[discountColId];

			const isPartyLevelDiscEnabled = row.cells[isPartyLevelDiscEnabledColId];
			// Treat an explicitly entered 0 the same as any other entered discount value, don't mark it as MIXED
			if ((discountValue !== null && discountValue !== undefined && discountValue !== '' && !Number.isNaN(+discountValue))) {
				return false;
			} if (isPartyLevelDiscEnabled === false) {
				return false;
			}
			return true;
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.ZakazkaCiziVykony.rows = rows;
		},
		async updateRow(rowUpdateData: {
			tableName: string;
			updateStatus: EditableStatus;
			rowId: number;
			row: Row;
		}) {
			const laborId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			const row: any = this.dependentTables.ZakazkaCiziVykony.rows.find((item: Row) => item.cells[laborId] === rowUpdateData.rowId);
			if (rowUpdateData.updateStatus === EditableStatus.DELETED) {
				
				const lineItemStatusId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.LINE_ITEM_STATUS;
				if (this.dmsSys.IsActivityEndTimePrp) {
					if (row.cells[lineItemStatusId] !== null) {						
						showAlert({
							message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						return;						
					}
				}

				let isAnyPartyInvoiced = await this.isAnyLabourInvoiced(this.ZakazkaId, row.cells[laborId], EXTLABOUR);			

				if (isAnyPartyInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;			
				}


				this.showConfirm({
				message:  this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
				title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
					options: {
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
						callback: async (action) => {
							if (action === 'confirm') {
								const Id = row.cells[laborId]
								this.$store.commit(`${this.storeUri}/${START_LOADING}`);
								await apiProvider.DeleteExternLabor(Id);
								await this.fetchTableData([EXT_LO_TABLE]);
								this.$store.commit(`${this.storeUri}/${END_LOADING}`);
							}
						}
					},
				});
			}
		},
		async showConfirmMessage(message: string) {
			return this.showConfirm({
				message: this.LocalizeChyboveHlasky(message),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
		},
		async createRow() {

			if(!this.CanAddExtLabour) {
				showAlert({
						message: this.LocalizeChyboveHlasky('ONLY_WARRANTY_GOODWILL_PENDING'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
			}

			const eoTypeIndex: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXTERNAL_OPERATION_TYPE_ID;
			const defaulteEoType: any = this.dropdownList.ExternalOperationType.find(
				(item: any) => item.Text === 'Labor',
			)!;
			this.eoTypeId = defaulteEoType.Value;
			this.isDiscountEditable = true;
			this.isElementEditable = true;
			if (!this.canEditTableInReleaseMode) {
				if (this.dmsSys.WorkItemPrp && this.edit.IsAllItemLevelStatusEntered) {
					const areAllItemsCompleted = !await this.showConfirmMessage('IsAllItemCompleted');
					if (areAllItemsCompleted) return;
				}
			}
			(this.$refs.editableTable as any).createRow();
			this.extLaborPrice = MIN_FIELD_LEVEL;
		},
		async onExtLaborCodeChange(value: string, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			let result: any = this.dropdownList.ExtLoCodes.find(
				(item: any) => item.Value === value
			)!;
			let descriptionColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.TEXT;
			updateCol(result?.Text, descriptionColId);
		},
		async onExternalOperationTypeChange(value: number, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			this.eoTypeId = value;
			let result: any = this.dropdownList.ExternalOperationType.find(
				(item: any) => item.Value === value
			)!;
			let eoTypeColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXTERNAL_OPERATION_TYPE_ID;			
			updateCol(result?.TEXT, eoTypeColId);
		},
		getLaborCode(row: Row, columnId: number) {
			let result: DropdownItem = this.dropdownList.ExtLoCodes.find(
				(item: DropdownItem) => item.Value === row.cells[columnId]
			)!;
			return result?.Value;
		},
		
		getExternalOperationTypeCode(row: Row, columnId: number) {
			const result: any = this.dropdownList.ExternalOperationType.find(
				(item: any) => item.Value === parseInt(row.cells[columnId])
			)!;
			return result?.Text;
		},
		onSplitSharesDialogClosed() {
			this.loading = false;
		},
		getServiceJob(row: Row, columnId: number) {
			let result: DropdownItem = this.dropdownList.ServiceJobForItems.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId])
			)!;
			return result?.Text;
		},
		async onUnitOfMeasurementChange(value: string, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			let result: any = this.dropdownList.UnitOfMeasurements.find(
				(item: any) => item.Value === value
			)!;
			let uomColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.UNIT_OF_MEASUREMENT;			
			updateCol(result?.Value, uomColId);
		},
		getUnitOfMeasurement(row: Row, columnId: number) {
			let result: DropdownItem = this.dropdownList.UnitOfMeasurements.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId])
			)!;
			return result?.Text;
		},
		async onSupplierChange(value: string, columnId: number, updateCol: any, row: Row) {
			updateCol(value, columnId);
			let result: any = this.dropdownList.LocalSuppliers.find(
				(item: any) => item.Value === value
			)!;
			let supplierColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.SUPPLIER_NAME;			
			updateCol(result?.Value, supplierColId);
		},
		getSupplier(row: Row, columnId: number) {
			let result: DropdownItem = this.dropdownList.LocalSuppliers.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId])
			)!;
			return result?.Text;
		},
		async isAnyLabourInvoiced(orederId: number, itemId: number, itemType:string) {
			const { data: isInvoiced } = await apiProvider.isPartOrLabourInvoiced(orederId, itemId, itemType);
			return isInvoiced;
		 },
		isSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},
		async isWarrantyOrGoodwillExistInServiceJobSplit(serviceJobId:number){
			const response = await apiProvider.isWarrantyOrGoodwillExistInServiceJobSplit(this.ZakazkaId!, serviceJobId);
			return response?.data;
		},
		redirectToSplitBilling(): boolean {
			return (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && this.isEditMode);
		},
		async cellClick(row: any, column: any, cell: any) {
			if (this.isSplitBillingAvailableForOrderType()) {
				let cols : number[] = [];
				let priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaCiziVykony.columns.filter((item)=> item.columnName === this.extLaborCols.PC_WITH_GST || item.columnName === this.extLaborCols.PC_VC_DPH_NAD || item.columnName === this.extLaborCols.PC_BEZ_DPH_NAD);
				priceWithoutGstCol.forEach(col => {
					cols.push(parseInt(col!.columns!.find((item)=> item.columnName === this.extLaborCols.PC_PP_SL_PO)!?.columnId));
				});
				let labourNumberColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
				const totalDiscount: number = this.calculateTotalDiscount(row);
				if (this.redirectToSplitBilling() && cols.includes(column)) {
					const itemId = row.cells[labourNumberColId];
					const extLabourId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.CV_NR;
					const extLabourCode = row.cells[extLabourId];
					const extOperationTypeId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXTERNAL_OPERATION_TYPE_ID;
					 const extOperationTypeCode = row.cells[extOperationTypeId];					
					const unitOfMEasurmentId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.UNIT_OF_MEASUREMENT;

					const unitOfMeasurment = this.dropdownList.UnitOfMeasurements.find(
												(item: any) => item.Value == row.cells[unitOfMEasurmentId],
											)!;
					const extQuantityId = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXT_LO_QUANTITY;
					const extQuantity = row.cells[extQuantityId];

					openList(SPLIT_BILLING, {
						filter: {
							ItemType: EXTLABOUR,
							ServiceOrderId: this.ZakazkaId,
							ItemId: itemId,
							Modified: totalDiscount,
							OrderStatus: this.zakazkaStav,
							ExtLabourCode: extLabourCode,
							ExternalLaborTypeId: extOperationTypeCode,
							UnitOfMeasurment: unitOfMeasurment?.Text,
							ExteQuantity: extQuantity,
						},
					}, { ServiceOrderId: this.ZakazkaId, ItemId: itemId, ItemType: EXTLABOUR, Modified: totalDiscount, OrderStatus: this.zakazkaStav,ExtLabourCode: extLabourCode,ExtOperationTypeCode: extOperationTypeCode,UnitOfMeasurment: unitOfMeasurment?.Text,ExteQuantity: extQuantity});
				} else if (column === this.dependentTables.ZakazkaCiziVykony.cellNames!.BILL_TO) {
					const itemId = row.cells[labourNumberColId];
					this.table = [];
					this.getSplitShareDetails(itemId);
					this.showSplitSharesDialog = true;
				}
			}
		},
		async getSplitShareDetails(itemId: number | null) {
			this.loading = true;
			const response = await apiProvider.getSplitDetails(itemId, this.ZakazkaId!);
			this.loading = false;
			this.table = response?.data;
		},

		calculateDiscountValue(row: Row) {
			const amountAfterDiscountIndex = this.dependentTables.ZakazkaCiziVykony.cellNames?.PC_SLEVA_PO;
			const priceBeforeDiscountIndex = this.dependentTables.ZakazkaCiziVykony.cellNames?.PC_CEL_SL_PRED;
			const priceBeforeDiscount = Number(row.cells[priceBeforeDiscountIndex as number]) || 0;
			const totalDiscount: number = this.calculateTotalDiscount(row);
			const calculateDiscountAmount: number = priceBeforeDiscount * (totalDiscount / 100);
			row.cells[amountAfterDiscountIndex as number] = +(priceBeforeDiscount - calculateDiscountAmount).toFixed(2);
		},

		calculateTotalDiscount(row: Row) : number {
			const lineItemDiscountColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames?.DISCOUNT_PERCENT!;
			const lineItemDiscountValue: number = Number(row.cells[lineItemDiscountColId]) || 0;
			this.totalDiscount = lineItemDiscountValue;
			return this.totalDiscount;
		},
		laborCompletionStatusCheck(row: Row): boolean {
			return (row.cells[this.dependentTables.ZakazkaCiziVykony.cellNames!.LINE_ITEM_STATUS as number] !== null);
		},
		async onServiceJobChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (value !== null)
			{
			 const newServiceJobId = parseInt(value);
			 this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			 
			 if(await this.isSagaSplitPartyExistInServiceJob(newServiceJobId))
			 {
				 showAlert({
						message: this.LocalizeChyboveHlasky('Service_job_with_SAGA_Split'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				  const previousServiceJobId= parseInt(row.cells[columnId]);
			  	  updateCol(previousServiceJobId, columnId);
				  row.cells[columnId] = previousServiceJobId;
				  this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				  return;
			 }
			 
				const invoiceStatus = await this.isAnyServiceJobSplitPartyInvoiced(newServiceJobId, row);
				if (invoiceStatus.IsServiceJobPartyInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Invoice_Generated_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsPrimaryCustomerInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Primary_Customer_Invoiced_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsServiceJobViolatingDiscountLimit) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Service_Job_Violates_Discount_Limit_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				}
				else {
					if(this.isServiceJobSplitBillingAvailableForOrderType())
					{
						updateCol(newServiceJobId, columnId);
						row.cells[columnId] = value;
					}
					else
					{
					showAlert({
							message: this.LocalizeChyboveHlasky('SJ_Split_Warning_Msg'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						}); 
					}
			  }
			  if (!invoiceStatus.IsAnyDiscountPercentAndAmount){
					const discountPercentColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT;
					const discountAmountColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_VAL;
						updateCol(0, discountPercentColId);
					updateCol(0, discountAmountColId);
					row.cells[discountPercentColId] = 0;
					row.cells[discountAmountColId] = 0;
				}
			 this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
			else
			{
				updateCol(null, columnId);
				row.cells[columnId] = null;
			}
		},
		async isAnyServiceJobSplitPartyInvoiced(serviceJobId:number, row: Row) {
			const laborColId: number = this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID;
			const itemId = row.cells[laborColId];
			const discountLimitPercent = this.loggedUser.DiscountLimitConfigData?.LaborItemPer ?? 0;
			const { data: isInvoiced } = await apiProvider.fetchInvoiceStatusOfServiceJobParty(this.ZakazkaId, serviceJobId, itemId, EXTLABOUR, discountLimitPercent);
			return isInvoiced;
		},
		async isSagaSplitPartyExistInServiceJob(serviceJobId:number){
			const { data: isSagaSplitPartyExists } = await zakazkaApiProvider.isSagaSplitsExistInServiceJobSplit(serviceJobId, this.ZakazkaId);
			return isSagaSplitPartyExists;
		},
		isServiceJobSplitBillingAvailableForOrderType(): boolean {
			return (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA);
		},

		validateRowLevelDiscount(value: any, updateCol: any, row: Row): boolean {
			const discountPercentColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_VAL;
			const priceBeforeDiscountColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.PC_CEL_SL_PRED;
			const discountPercent = value;
			const configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.LaborItemPer;
			if (value === null || value === undefined || value === '') {
				return true;
			}
			const percentValue = +(_.defaultTo(discountPercent, 0));
			const totalDiscountPercent = +(_.defaultTo(discountPercent, 0));
			if (percentValue < 0 || percentValue > 100) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
				updateCol(null, discountPercentColId);
				// updateCol(null, discountAmountColId);
				return false;
			}

			if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && totalDiscountPercent > configuredDiscountLimit) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_EXCEEDS_LIMIT') });
				updateCol(null, discountPercentColId);
				// updateCol(null, discountAmountColId);
				return false;
			}

			updateCol(percentValue, discountPercentColId);
			// Reset discount amount to original value when discount percent is changed. This is to avoid any mismatch between discount percent and discount amount.
			// updateCol(this.originalDiscountAmount, discountAmountColId);
			if (percentValue > 0) {
				updateCol(null, discountAmountColId);
			}
			return true;
		},

		onRowDiscountAmountLeave(value: any, row: Row, columnId: number, updateCol: any): Boolean {
			console.log(`onRowDiscountAmountLeave called at ${new Date().toISOString()}`);
			const discountPercentColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.DISCOUNT_VAL;
			const unitPriceColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXT_LO_UNIT_PRICE;
			const quantityColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.EXT_LO_QUANTITY;
			const discountAmount = value;
			if (discountAmount === undefined) {
				return true;
			}
			if (discountAmount === null || discountAmount === undefined || discountAmount === '') {
				// updateCol(null, discountPercentColId);
				return false;
			}

			const amountValue = +discountAmount;
			if (Number.isNaN(amountValue) || amountValue < 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
				updateCol(null, discountAmountColId);
				// updateCol(null, discountPercentColId);
				return false;
			}

			const itemId: number = +(row.cells[this.dependentTables.ZakazkaCiziVykony.cellNames!.ZAZNAM_ID] ?? 0);
			if (itemId <= 0) {
				const originalPrice = +(row.cells[unitPriceColId] ?? 0) * +(row.cells[quantityColId] ?? 1);
				if (amountValue > originalPrice) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger') });
					updateCol(null, discountAmountColId);
					return false;
				}
			}
			updateCol(amountValue, discountAmountColId);
			// Reset discount percent to original value when discount amount is changed. This is to avoid any mismatch between discount percent and discount amount.
			// updateCol(this.originalDiscountPercent, discountPercentColId);
			if (amountValue > 0) {
				updateCol(null, discountPercentColId);
			}
			return true;
		},

	},
});
